import { ModalType } from '@appTypes/EligibilityApi.interface'

export const getRatesAndFeesModalInformation = (modalType: ModalType) => {
    switch (modalType) {
        case ModalType.BalanceTransferOfferModal:
            return {
                title: 'Balance Transfer Offer',
                description:
                    'Some cards offer a special introductory interest rate on balances transferred from another credit card. Rates and duration can differ depending on individual circumstance.',
                items: [
                    {
                        title: 'Intro Rate',
                        description:
                            'The lowest interest rate you will be charged over the balance transfer period on any balance transferred to the card depending on individual circumstance.',
                    },
                    {
                        title: 'Duration',
                        description:
                            'The length of time that you will be charged the introductory rate on any balance transferred to the card.',
                    },
                    {
                        title: 'Transfer Fee',
                        description:
                            'The one off handling fee that you will have to pay if you transfer a balance.',
                    },
                ],
            }

        case ModalType.PurchaseOfferModal:
            return {
                title: 'Purchase Offer',
                description:
                    'Some cards offer a special introductory interest rate on spending on the card.',
                items: [
                    {
                        title: 'Intro Rate',
                        description:
                            'The lowest interest rate you will be charged over the purchase period on any new spending on the card depending on individual circumstance.',
                    },
                    {
                        title: 'Duration',
                        description:
                            'The length of time that you will be charged the introductory rate on new spending.',
                    },
                ],
            }

        case ModalType.AnnualInterestRatesModal:
            return {
                title: 'Annual Interest Rates',
                description:
                    'The Annual Interest Rate is the lowest interest rate that you will be charged on different types of borrowing after the end of any introductory offers. However, you may be charged higher rates depending on individual circumstance.',
                items: [
                    {
                        title: 'Balance Transfers',
                        description:
                            'The lowest interest rate you will be charged on balance transfer after the end of any introductory offers depending on individual circumstance.',
                    },
                    {
                        title: 'Purchases',
                        description:
                            'The lowest interest rate you will be charged on new spending after the end of any introductory offers depending on individual circumstance.',
                    },
                    {
                        title: 'Cash Withdrawals',
                        description:
                            'The lowest interest rate you will be charged on any cash withdrawals you make with the card depending on individual circumstance.',
                    },
                ],
            }

        case ModalType.OtherKeyFactsModal:
            return {
                title: 'Other Key Facts',

                items: [
                    {
                        title: 'Annual Fee',
                        description:
                            'Some cards charge an annual fee, although the majority are fee free.',
                    },
                    {
                        title: 'Overseas Transaction Fee',
                        description:
                            'The proportion of any overseas transaction you make on the card that you will be charged as fee.',
                    },
                ],
            }

        default:
            return {}
    }
}
